import {Component, ViewChild} from '@angular/core';
import {combineLatest, Observable, of, ReplaySubject} from "rxjs";
import {catchError, delay, distinctUntilChanged, map, shareReplay} from "rxjs/operators";
import {Survey} from "@shared/models/Survey";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {BackendService} from "@core/backendService/backend.service";
import {Configuration} from "@shared/models/Configuration";


@Component({
  selector: 'app-user-survey-table',
  templateUrl: './user-survey-table.component.html',
  styleUrls: ['./user-survey-table.component.scss']
})
export class UserSurveyTableComponent {
  constructor(private readonly backendService: BackendService) {}

  public displayedColumns: string[] = ["title", "points", "customStatus"]
  public pageSize: number = 10

  @ViewChild(MatSort, { static: false })
  private set matSort(sort: MatSort){this.sort$.next(sort)}
  public sort$: ReplaySubject<MatSort> = new ReplaySubject<MatSort>(1)
  public configuration$: Observable<Configuration> = this.backendService.config$

  @ViewChild(MatPaginator, { static: false })
  private set matPaginator(paginator: MatPaginator){this.paginator$.next(paginator)}
  public paginator$: ReplaySubject<MatPaginator> = new ReplaySubject<MatPaginator>(1)

  public hasCompletedInitialSurvey$: Observable<boolean> = this.backendService.hasCompletedInitialSurvey$
  public initialSurvey$: Observable<Survey> = this.backendService.initialSurvey$
  public isSyncInProgress$: Observable<boolean> = this.backendService.isParticipantSurveyLoading$

  public surveys$:Observable<MatTableDataSource<Survey>> =
      combineLatest([this.backendService.participantSurvey$, this.sort$, this.paginator$])
      .pipe(
          // @TODO: make some visual feedback of the error
          catchError((e: any) => {return of([[], undefined, undefined])}),
          // distinctUntilChanged((prev, curr) =>prev[0] === curr[0] && prev[1] === curr[1] && prev[2] === curr[2]),
          map(([response, sort, paginator]: [Survey[], MatSort, MatPaginator]) => {
            const datasource = new MatTableDataSource<Survey>(response);
            this.initSort(sort, datasource);
            this.initPaginator(paginator, datasource);
            return datasource
          }),
          delay(0),
          shareReplay(1)
      )

  private initSort(sort: MatSort, datasource: MatTableDataSource<Survey>){
    datasource.sortingDataAccessor = (survey: Survey, sortHeaderId: string) => {
      if(sortHeaderId === 'customStatus') {
        let isCompleted = survey.completed !== undefined && survey.completed
        let isActive = survey.active !== false
        let completed = isCompleted ? 1 : 0
        let active = isActive ? 0 : 10
        let missed = !isCompleted && !isActive ? 100 : 0
        return completed + active + missed
      }
      let defaultSort = survey[sortHeaderId as keyof Survey]
      if(typeof defaultSort === 'boolean') return defaultSort ? 1 : 0
      return defaultSort
    }
    datasource.sort = sort;
  }

  private initPaginator(paginator: MatPaginator, datasource: MatTableDataSource<Survey>){
    if(!!datasource && !!paginator) {
      paginator.pageIndex = 0
      datasource.paginator = paginator;
    }
  }
}
